
var AuthUtil={
    isLogin: function () {
        var user = sessionStorage.getItem("user");
        if (user == null || user === 'null'){
          return false;
        } else{
          return true;
        }
    },
}

var StorageUtil = {
    storeString: function (key, value) {
        sessionStorage.setItem(key, value);
    },

    storeObject: function (key, object) {
        sessionStorage.setItem(key, JSON.stringify(object));
    },

    getString: function (key) {
        return sessionStorage.getItem(key);
    },

    getObject: function (key) {
        return JSON.parse(sessionStorage.getItem(key));
    },

    removeObject:function (key) {
      sessionStorage.removeItem(key);
    }
}
var LocalStorageUtil = {
  storeString: function (key, value) {
    localStorage.setItem(key, value);
  },

  storeObject: function (key, object) {
    localStorage.setItem(key, JSON.stringify(object));
  },

  getString: function (key) {
    return localStorage.getItem(key);
  },

  getObject: function (key) {
    return JSON.parse(localStorage.getItem(key));
  },

  removeObject:function (key) {
    localStorage.removeItem(key);
  }
}
export{AuthUtil, StorageUtil,LocalStorageUtil};
